import { Component, OnDestroy, OnInit } from '@angular/core';
import { MyUnitService } from '@services/unit-activity/my-unit/my-unit.service';
import { MyEquipmentService } from '@techwan/ionic-core';
import { Subscription } from 'rxjs';
import { JoinUnitWithQRCodeService } from '../../services/join-unit-with-qr-code/join-unit-with-qr-code.service';

@Component({
  selector: 'app-qr-code-view',
  templateUrl: './qr-code-view.component.html',
  styleUrls: ['./qr-code-view.component.scss']
})
export class QRCodeViewComponent implements OnInit, OnDestroy {
  private unitChangeSub: Subscription = null;

  qrData: string;
  isEngaged: boolean = false;

  constructor(
    private myEquipment: MyEquipmentService,
    private myUnit: MyUnitService,
    private joinUnitWithQrCode: JoinUnitWithQRCodeService
  ) {}

  ngOnInit() {
    this.myEquipment.myDevice.subscribe(communicationEquipment => (this.qrData = communicationEquipment.Name)).unsubscribe();

    this.onMyUnitChange();
    this.unitChangeSub = this.myUnit.$change.subscribe(() => this.onMyUnitChange());
  }

  private onMyUnitChange() {
    this.isEngaged = this.myUnit.isEngaged();
  }

  ngOnDestroy(): void {
    this.unitChangeSub.unsubscribe();
  }

  onScanQrCode() {
    this.joinUnitWithQrCode.joinUnit();
  }
}
